import React from 'react';
import PropTypes from 'prop-types';
import { RichContent } from '../elements/index';

export const TextComponent = (props) => {
  const {content} = props;
		return(
			<section className="kiwi-text">
				<div className="container">
					<div className="row">
{/* bootstrap column removed as padding is added via flexbox class */}
						<div className="text-columns">
							{ Object.values(content).map((content, index) => {
								return (
									content.length > 0 &&
									<div key={index} className='text-columns__item'>
										<RichContent dangerous={content}/>
									</div>
								)
							})
							}
						</div>
					</div>
				</div>
			</section>
		)
};

TextComponent.propTypes = {
	content: PropTypes.object
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/components/TextComponent.js